// extracted by mini-css-extract-plugin
export default {"container":"safety_container__IEvwX","text":"safety_text__gYbtD","logo":"safety_logo__288XF"};